import { SearchFilterField } from '@retail/components';
import { useProductsTFunction } from '@retail/products/i18n';

interface Props {
  isDisabled?: boolean;
  searchTerm?: string;
  includeLabel?: boolean;
  label?: string;
  placeholder?: string;
  size?: 'small' | 'medium';
  width?: string | number;
  onSubmitSearch: (search: string) => void;
}

export function MgSupplierItemSearchField({
  isDisabled = false,
  searchTerm,
  includeLabel = true,
  label,
  placeholder,
  size = 'medium',
  width,
  onSubmitSearch,
}: Props) {
  const t = useProductsTFunction();

  return (
    <SearchFilterField
      label={includeLabel ? label ?? t('products.search.openSearch.label') : undefined}
      placeholder={placeholder ?? t('products.search.searchItems')}
      searchTerm={searchTerm}
      isDisabled={isDisabled}
      size={size}
      width={width}
      onSubmitSearch={onSubmitSearch}
    />
  );
}
